<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="常用语：">
            <el-input v-model="query.title" placeholder="请输入常用语" clearable size="small" />
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.isEnable" placeholder="请选择" clearable size="small">
              <el-option label="启用" :value="true"></el-option>
              <el-option label="禁用" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" v-hasPermi="['customer:phrases:add']">新建常用语</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="常用语" prop="title" align="center" width="200" fixed show-overflow-tooltip />
        <el-table-column label="状态" prop="isEnable" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.isEnable" :active-value="true" :inactive-value="false" @change="changeSwitch(row)" v-hasPermi="['customer:phrases:state']"></el-switch>
            {{row.isEnable?'启用':'禁用'}}
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" />
        <el-table-column label="操作人" prop="operatedName" align="center" />
        <el-table-column label="操作" align="center" width="230" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)" v-hasPermi="['customer:phrases:edit']">编辑</el-button>
            <el-button type="text" @click="handleDeleteSingle(row)" v-hasPermi="['customer:phrases:delete']">删除</el-button>
            <el-button type="text" @click="handleLog(row)">日志记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <phrases-add ref="phrasesAdd" @created="doQueryList({})" />
  </div>
</template>

<script>
import phrasesAdd from './add.vue'
import custServiceSpeechcraftApi from '@/api/customer/custServiceSpeechcraft'
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination,
    phrasesAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        title: undefined,
        isEnable: undefined,
        isGetCustServiceStaffId: true
      },
      selectItems: [],
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleFilter() {
      this.query.title = undefined
      this.query.isEnable = undefined
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return custServiceSpeechcraftApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => custServiceSpeechcraftApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择数据')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => custServiceSpeechcraftApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      custServiceSpeechcraftApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.phrasesAdd.handleCreate(row)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.phrasesAdd.handleUpdate(row)
    },
    handleLog(row) {
      this.$router.push("/log/log?type=81&id=" + row.id);
    }
  }
}
</script>
<style lang="scss" scoped>
.coutomer-time {
  i {
    font-size: 16px;
    color: #1596cd;
    cursor: pointer;
    padding-left: 5px;
  }
}
</style>